<template>
  <lazy-div :load="doInit">
    <v-card>
      <v-card-title primary-title>
        <h3 class="headline mb-0">Print Cargo Cover Note</h3>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field v-model="reportForm.numberOfDuplicates" :label="labels.numberOfDuplicates" v-validate="'numeric'" :data-vv-as="labels.numberOfDuplicates" data-vv-name="numberOfDuplicates" :error-messages="errors.collect('numberOfDuplicates')"></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field v-model="reportForm.numberOfCopies" :label="labels.numberOfCopies" v-validate="'numeric'" :data-vv-as="labels.numberOfCopies" data-vv-name="numberOfCopies" :error-messages="errors.collect('numberOfCopies')"></v-text-field>
              </v-flex>
            <v-flex lg6 xs12>
              <v-checkbox v-model="reportForm.sendEmail" :label="labels.sendEmail" data-vv-name="sendEmail" :data-vv-as="labels.sendEmail"></v-checkbox>
            </v-flex>
            <v-flex lg6 xs12></v-flex>
            <v-flex xs12 class="mt-3">
              <form>
                <v-expansion-panel expand :value="[true]">
                  <v-expansion-panel-content>
                    <div slot="header">
                      <v-icon>mdi-filter-variant</v-icon> Filters
                    </div>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field v-model="filters.proposalNo" :label="filtersLabel.proposalNo" type="tel" :error-messages="errors.collect('proposalNo')" data-vv-name="proposalNo" :data-vv-as="filtersLabel.proposalNo" v-validate="'numeric'"></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-autocomplete :items="intermediaryList" v-model="filters.intermediary" :label="filtersLabel.intermediary" item-text="label" item-value="value" data-vv-name="intermediary" :data-vv-as="filtersLabel.intermediary" :error-messages="errors.collect('intermediary')" clearable></v-autocomplete>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field v-model="filters.appName" :label="filtersLabel.appName" :error-messages="errors.collect('appName')" data-vv-name="appName" :data-vv-as="filtersLabel.appName" v-validate="'name|max:60'"></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field v-model="filters.coyName" :label="filtersLabel.coyName" :error-messages="errors.collect('coyName')" data-vv-name="coyName" :data-vv-as="filtersLabel.coyName" v-validate="'name|max:60'"></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg6 xs6>
                              <cal-picker v-model="filters.createdDateFrom" :label="filtersLabel.createdDateFrom" :data-vv-as="filtersLabel.createdDateFrom" data-vv-name="createdDateFrom" :error-messages="errors.collect('createdDateFrom')"></cal-picker>
                            </v-flex>
                            <v-flex xl3 lg6 xs6>
                              <cal-picker v-model="filters.createdDateTo" :label="filtersLabel.createdDateTo" :data-vv-as="filtersLabel.createdDateTo" data-vv-name="createdDateTo" :error-messages="errors.collect('createdDateTo')"></cal-picker>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                        <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </form>
            </v-flex>
          </v-layout>
        </v-container>
        <form>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 class="pt-2">
                <v-data-table :headers="this.headers" :items="items" item-key="proposalNo" :pagination.sync="pagination" :total-items="totalItems" :loading="loading" class="elevation-1" :rows-per-page-items="itemsPerPage" :no-data-text="noDataText">
                  <template slot="items" slot-scope="props">
                    <td align='center'>
                      <v-tooltip bottom>
                        <v-btn icon slot="activator" color="primary" flat type="submit" :loading="submitting" @click.prevent="doExport(props.item.proposalNo)">
                          <v-icon dark>mdi-file-export</v-icon>
                        </v-btn>
                        <span>{{labels.export}}</span>
                      </v-tooltip>
                    </td>
                    <td>{{ props.item.proposalNo }}</td>
                    <td>{{ props.item.intermediaryName }}</td>
                    <td>{{ props.item.appName }}</td>
                    <td>{{ props.item.createdDate }}</td>
                    <td>{{ formatDisplayDate(props.item.inForceDate) }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
    </v-card>
  </lazy-div>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import clone from 'clone'
import { removeTime, setEndTime, formatDisplayDate, formatDisplayDateTime2 } from '@/utils/date'

export default {
  data() {
    return {
      totalItems: 0,
      headers: [
        { text: 'Action', align: 'center', sortable: false, value: '' },
        { text: 'Proposal No.', align: 'left', value: 'proposalNo' },
        { text: 'Intermediary', value: 'intermediaryName' },
        { text: 'Applicant Name', value: 'appName' },
        { text: 'Entry Date', value: 'createdDate' },
        { text: 'Approved Date', value: 'inForceDate' }
      ],
      filters: {
        proposalNo: undefined,
        intermediary: undefined,
        appName: undefined,
        coyName: undefined,
        createdDateFrom: undefined,
        createdDateTo: undefined
      },
      filtersLabel: {
        proposalNo: 'Proposal No.',
        intermediary: 'Intermediary',
        appName: 'Applicant Name',
        coyName: 'Company Name',
        createdDateFrom: 'Entry Date From',
        createdDateTo: 'Entry Date To'
      },
      labels: {
        customName: 'Report Name',
        proposalNo: 'Proposal No.*',
        numberOfDuplicates: 'Number Of Duplicates*',
        numberOfCopies: 'Number Of Copies*',
        format: 'Export Format',
        export: 'Export',
        sendEmail: 'Send Output to Email?'
      },
      reportForm: {
        customName: undefined,
        proposalNo: undefined,
        printOriginal: false,
        numberOfDuplicates: undefined,
        numberOfCopies: undefined,
        format: undefined,
        sendEmail: false
      },
      menu: {},
      intermediaryList: [],
      supportedFormat: [],
      submitting: false
    }
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.reportForm.format = value[0].value
      }
    },
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData()
    },
    'pagination.page': function (value) {
      this.fetchData()
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData()
    },
    'pagination.sortBy': function (value) {
      this.fetchData()
    }
  },
  methods: {
    async doInit() {
      try {
        const apiURI = this.$store.state.reports.agencyReports.menu.cargoPrintCN
        const result = await this.$http.get(apiURI)
        this.reportForm.numberOfDuplicates = 1
        this.reportForm.numberOfCopies = 0
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.intermediaryList = data.intermediaryList

            this.menu = extractMenu(result.data._links)
            this.fetchData()
          }
        }
      } catch (err) {
        throw err
      }
    },
    async fetchData() {
      const apiUrl = this.menu.proposalList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: rowsPerPage
          }
          // Massage the filters
          let massageFilters = clone(this.filters)
          if (massageFilters.createdDateFrom) {
            massageFilters.createdDateFrom = formatDisplayDateTime2(removeTime(massageFilters.createdDateFrom))
          }
          if (massageFilters.createdDateTo) {
            massageFilters.createdDateTo = formatDisplayDateTime2(setEndTime(massageFilters.createdDateTo))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.descending))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              data.map(row => {
                if (row.createdDate) {
                  row.createdDate = this.formatDate(row.createdDate)
                }
              })
              this.$set(this, 'items', data)
            } else {
              this.$set(this, 'items', [])
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doExport(proposalNo) {
      this.reportForm.proposalNo = proposalNo
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.reportForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doClearFilters() {
      this.filters.proposalNo = null
      this.filters.intermediary = null
      this.filters.appName = null
      this.filters.coyName = null
      this.filters.createdDateFrom = null
      this.filters.createdDateTo = null
      this.fetchData()
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData()
        }
      })
    },
    formatDisplayDate(date) {
      return formatDisplayDate(date)
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">

</style>
